<template>
    <div class="md product-list" v-if="user.rfno && userNotification.length">
        <ul>
            <li
                v-for="item in userNotification"
                :class="[item.is_read? '': 'not-yet']"
                :key="item['data-id']"
            >
                <a
                    class="div"
                    @click="showMsg(item)"
                >
                    <div class="image" >
                        <div
                            v-if="item.img"
                            class="mask"
                            :style="'background-image: url('+ item.img +')'"
                        ></div>
                        <div v-else
                            class="mask is-alert"
                        ></div>
                    </div>
                    <div class="essay">
                        <div class="func">
                            <ul>
                                <li
                                    v-if="item.url"
                                    class="is-link"
                                >
                                    <div class="a" :title="$t('page.notification.func.showorder')">
                                        <span>{{ $t('page.notification.func.showorder') }}</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="caption">{{ item.title }}</div>
                        <div class="p">{{ item.body }}</div>
                        <div class="label">{{ getTime(item.time_send) }}</div>
                    </div>
                </a>
            </li>
        </ul>
    </div>
    <div
        v-else
        class="md"
    >
        <cpStatus
            tag="div"
            themes="warning"
            icon="warning"
            :text="$t('page.orderhistory.status.noresults')"
        ></cpStatus>
    </div>
</template>

<script>
    import cpStatus from '@/components/cpStatus'

    import { mapState, mapMutations } from 'vuex'

    export default {
        components: {
            cpStatus,
        },
        data: function(){

            return {
                loadingState: false, //是否讀取中
                end: false, //是否沒有消息了
            }
        },
        computed: {
            ...mapState([
                'user',
                'userNotification',
            ]),
            length: function() {
                let $userNotification = this.userNotification,
                    $filter = $userNotification.filter(item => !item.is_read);

                return $filter.length || 0
            }
        },
        methods: {
            ...mapMutations([
                'catchError',
                'pushPopUp',
                'userNotificationGet',
                'userNotificationAdd',
                'globalScrollFuncQueuePush',
                'globalScrollFuncQueueClear'
            ]),
            addLoading: function(){
                let _scrollTop = window.pageYOffset,
                    _windowHeight = window.innerHeight,
                    _top = Math.ceil(_scrollTop + _windowHeight);

                let _pageHeight = document.body.clientHeight;

                if( _top >= _pageHeight && !this.loadingState && !this.end ) {
                    this.$set(this, 'loadingState', true);
                    
                    this.loading();
                }else {
                    this.$set(this, 'loadingState', false);
                }
            },
            loading: function(){
                let $userNotification = this.userNotification,
                    $last = $userNotification[$userNotification.length - 1],
                    _time = $last.time_send;

                _time = _time.replaceAll('-', '/').replace('T', ' ').replace(/\.\d+/, '');

                let _url = this.$siteTool.apiUrl({
                        class: 'Notify',
                        func: 'List',
                    }),
                    $condition = {
                        date: _time,
                        topnum: 10,
                    }

                this.$http.post(_url, $condition).then(res => { //弄完所有設定後開始取資料

                    if( res.length ) {
                        this.userNotificationAdd(res);
                    }else {
                        this.$set(this, 'end', true);

                        this.pushPopUp({
                            type: 'alert',
                            content: {
                                html: this.$t('site.status.dataUndefined'),
                            }
                        });
                    }
                    
                    this.$set(this, 'loadingState', false);
                }).catch(error => {

                    this.catchError({
                        error: error,
                        callback: this.loading
                    });
                });
            },
            showMsg: function(item){
                item.is_read = true;

                this.userNotificationGet(item['data-id']);

                if( item.url ) {
                    this.$router.push(item.url);
                }else {

                    this.pushPopUp({
                        type: 'alert',
                        content: {
                            caption: item.title,
                            html: item.body,
                        }
                    });
                }
            },
            getTime: function(time){
                return this.$okaTool.timeInterval({
                    time: time,
                    unit: 'date'
                }).ymdhm;
            }
        },
        created: function() {

            this.globalScrollFuncQueuePush({
                id: this.id,
                func: this.addLoading
            });
        },
        destroyed: function(){
            this.globalScrollFuncQueueClear(this.id);
        },
    }
</script>

<style scoped lang="scss">
    
    .md.product-list {

        ul {
            @extend %reset;
        }

        $type: map-get($colors, 'danger');
        $text: map-get($type, 'text');

        li {
            padding: $interval-s;
            position: relative;

            &.not-yet {
                
                /*a*/.div {
                    // border: 2px solid $text;

                    &::before {
                        content: $content;
                    }
                }
            }
        }
        
        /*a*/.div {
            display: flex;
            color: inherit;
            cursor: pointer;

            @include media('mobile') {
                display: block;
                position: relative;
            }

            @include media('pad') {
                padding-left: 100px;
            }

            @include media('phone') {
                padding-left: 80px;
            }

            &:hover {

                .essay {
                    background-color: $white;
                }
            }

            &::before {
                position: absolute;
                top: 1px;
                left: 1px;
                width: $interval-m;
                height: $interval-m;
                border-radius: 50%;
                background-color: $text;
                z-index: 2;

                @include media('mobile') {
                    top: $interval-m * -0.5;
                    left: $interval-m * -0.5;
                }
            }
        }

        .image {
            position: relative;
            width: 120px;
            z-index: 1;

            @include media('mobile') {
                position: absolute;
                left: 0;
                top: 0;
                bottom: 0;
            }

            @include media('pad') {
                width: 100px;
            }

            @include media('phone') {
                width: 80px;
            }
            
            .mask {
                display: block;
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;
                border-radius: border-radius 0 0 border-radius;

                &.is-alert {
                    background-image: image-url('alert.svg');
                    background-size: 80%;
                }
            }
        }

        .essay {
            position: relative;
            padding: $interval-s;
            padding-left: $interval-m;
            transition: $transition;
            flex: 1;
            background-color: #ECECEC;
            border-radius: 0 border-radius border-radius 0;

            .func {
                position: absolute;
                bottom: 0;
                right: 0;

                @include media('mobile') {
                    display: none;
                }

                ul {
                    position: absolute;
                    right: $interval-s;
                    bottom: $interval-s;
                    white-space: nowrap;
                }

                li {
                    display: inline-block;

                    + li {
                        margin-left: $interval-s;
                    }

                    &.is-link {

                        .a {

                            &:before {
                                content: '\e14f';
                            }
                        }
                    }
                }

                .a {
                    $size: 18px;

                    display: block;
                    padding: $interval-s $interval-m;
                    line-height: $size;
                    color: $forth-color;
                    text-align: center;
                    cursor: pointer;
                    transition: $transition;
                    white-space: nowrap;
                    background-color: rgba-set($white, $opacity-m); 

                    &:hover {
                        background-color: $major-color;
                        color: $white;
                    }

                    &:before {
                        @extend %font-pseudo;
                        font-size: $font-size-xl;
                        display: block;
                        width: $size;
                        height: $size;
                        line-height: $size;
                        text-align: center;
                        cursor: pointer;
                        display: inline-block;
                        margin-right: $interval-s;
                    }
                }
            }

            .caption {
                font-size: $font-size-xl;

                @include media('mobile') {
                    font-size: $font-size-l;
                }
            }

            .p {
                color: $major-color;
                @extend %ellipsis;
                padding-bottom: $interval-m;
            }

            .label {
                margin-top: $interval-s;
            }
        }
    }
</style>
